const ommnio = {
  primary: {
    '2': '#0a0b10',
    '5': '#151626',
    '10': '#2d2f4f',
    '20': '#393c65',
    '30': '#45487c',
    '40': '#5154a0',
    '50': '#6269e5',
    '60': '#7d84ff',
    '70': '#9ea3ff',
    '80': '#bfc2ff',
    '90': '#e0e0ff',
    '95': '#f1efff',
    '98': '#fbf8ff',
    '99': '#fffbff',
  },
  secondary: {
    '2': '#05060a',
    '5': '#0d0d12',
    '10': '#1a1a24',
    '20': '#252633',
    '30': '#3d3f54',
    '40': '#55576d',
    '50': '#6e7087',
    '60': '#8789a1',
    '70': '#a1a3ba',
    '80': '#bcbed4',
    '90': '#d8daee',
    '95': '#ecedf8',
    '98': '#f8f9fd',
    '99': '#fcfcff',
  },
  tertiary: {
    '2': '#000a07',
    '5': '#00140f',
    '10': '#00201a',
    '20': '#00382d',
    '30': '#005143',
    '40': '#006b59',
    '50': '#008771',
    '60': '#00a389',
    '70': '#00c1a2',
    '80': '#35debd',
    '90': '#5dfbd9',
    '95': '#b8ffea',
    '98': '#e6fff6',
    '99': '#f3fff9',
  },
  neutral: {
    '2': '#06060a',
    '5': '#0d0d12',
    '10': '#1a1a24',
    '20': '#252633',
    '30': '#3d3f54',
    '40': '#55576d',
    '50': '#717397',
    '60': '#8487a6',
    '70': '#989ab4',
    '80': '#ababc2',
    '90': '#d8daee',
    '95': '#ecedf8',
    '98': '#f8f9fd',
    '99': '#fffbff',
  },
  neutralVariant: {
    '2': '#06060e',
    '5': '#0d0d18',
    '10': '#1a1b2e',
    '20': '#252633',
    '30': '#3a3a5e',
    '40': '#4a4c66',
    '50': '#717397',
    '60': '#8487a6',
    '70': '#989ab4',
    '80': '#ababc2',
    '90': '#d8daee',
    '95': '#ecedf8',
    '98': '#f8f9fd',
    '99': '#fffbff',
  },
  error: {
    '2': '#1a0000',
    '5': '#2d0001',
    '10': '#410002',
    '20': '#690005',
    '30': '#93000a',
    '40': '#ba1a1a',
    '50': '#de3730',
    '60': '#ff5449',
    '70': '#ff897d',
    '80': '#ffb4ab',
    '90': '#ffdad6',
    '95': '#ffedea',
    '98': '#fff8f7',
    '99': '#fffbff',
  },
  analogous: ['#6269e5', '#9d62e5', '#62aae5'],
  tetradic: ['#48ca82', '#cac348', '#484fca', '#ca4890'],
  icons: ['#31e17f', '#e1c931', '#484fca', '#e15331', '#ac31e1', '#31b8e1'],
};
export default ommnio;
